import { ClientesCesantesDTO, ModificarCesanteDTO, NuevoCesanteDTO } from "../models/clientesCesantes";
import { crearCesante, editarCesante } from "../service/serviceCesante";
import { getCurrentUsername } from '../../../../services/userRolesService';


export function useCesante(){
    const save = async (data: ClientesCesantesDTO, dataediting: ModificarCesanteDTO | undefined) => {

        let dataRequest: NuevoCesanteDTO = {
            mutuoId: data.mutuoId,
            numeroOperacion: data.numeroOperacion,
            omd: data.omd,
            fechaInicio: data.fechaInicio ?? new Date(),
            fechaTermino: data.fechaTermino ?? new Date(),
            fechaFiniquito: data.fechaFiniquito ?? new Date(),
            fechaUltimodificacion: data.fechaUltimodificacion ?? new Date(),
            detalle: data.detalle ?? "",
            login: getCurrentUsername(),
            rut: data.rut

        }

        if (dataediting) {
          return  await editarCesante(dataediting);

        }
        return await crearCesante(dataRequest);
        
}
return {
        save
    }
}